import * as vp from 'vopay';
import { useHistory } from 'react-router-dom';
import styles from './FAQCategoriesCard.module.scss';

const { SubTitle } = vp;

type FAQCategoriesCardProps = {
  title: string;
  info: string[];
  logo: string;
};

const FAQCategoriesCard: React.FC<FAQCategoriesCardProps> = ({ title, info, logo }) => {
  const history = useHistory();
  return (
    <div
      onClick={() => history.push(`/category/${title.toLowerCase().replace(/\s/g, '-')}`)}
      className={styles.faqCategoryContainer}
    >
      <div className={styles.faqCategoryContainer__innerWrapper}>
        <div className={styles.faqCategoryContainer__logo}>
          <img src={`data:image/png;base64,${logo}`} alt={title} />
        </div>
        <div className={styles.faqCategoryinfoContainer}>
          <div className={styles.faqCategoryinfoContainer__title}>
            <SubTitle subTitle={title} fontSize="20px" lineHeight="1.1" />
          </div>
          <div
            className={styles.faqCategoryinfoContainer__info}
            style={title === 'Customer Support' ? { listStyle: 'none' } : undefined}
          >
            {info.map((description) => {
              if (title !== 'Customer Support') {
                return <li>{description}</li>;
              } else {
                return <li style={{ textIndent: 'unset', paddingLeft: 'unset' }}>{description}</li>;
              }
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQCategoriesCard;
